type RouteNames = Record<Uppercase<string>, Lowercase<string>>

export const ROUTES = {
  PRODUCT_LIST: 'landing_page',
  SEARCH_RESULTS: 'search_page',
  SELLER_PRODUCT_LIST: 'merchant_landing',
} satisfies RouteNames
